import {MaterialModule} from "@modules/material.module";
import {AppCoreModule} from "@modules/app.core.module";
import {AppSharedModule} from "@modules/app-shared.module";
import {NgModule} from "@angular/core";

import {SettingsDetailsComponent} from '@features/settings/details/settings-details.component';
import {GlobalSettingsComponent} from '@features/settings/global-settings/global-settings.component';
import {HardwareSettingsComponent} from '@features/settings/hardware-settings/hardware-settings.component';
import {ManageListingComponent} from '@features/settings/manage-listing/manage-listing.component';
import {UploadOfferingListingPhotoDialogComponent} from '@features/settings/manage-listing/upload-offering-listing-photo-dialog/upload-offering-listing-photo-dialog.component';
import {BankingDetailsComponent} from '@features/settings/settings-billing-and-banking/banking-details/banking-details.component';
import {BillingDetailsComponent} from '@features/settings/settings-billing-and-banking/billing-details/billing-details.component';
import {SettingsBillingAndBankingComponent} from '@features/settings/settings-billing-and-banking/settings-billing-and-banking.component';
import {VerifyBankingDetailsComponent} from '@features/settings/settings-billing-and-banking/verify-banking-details/verify-banking-details.component';
import {UsersAndAccessComponent} from '@features/settings/users-and-access/users-and-access.component';
import {TemplateBuilderComponent} from '@features/settings/template-builder/template-builder.component';
import {FeaturePortalModule} from "./feature-portal.module";
import {
  AssignedSuppliersDialogComponent
} from "@features/settings/payments/assigned-suppliers-dialog/assigned-suppliers-dialog.component";
import {PaymentsSettingsComponent} from "@features/settings/payments/payments-settings.component";
import {
  AppCardActionsDirective,
  AppCardComponent,
  AppCardContentDirective
} from "projects/nter-ui-kit/src/lib/webkit/components/card/card.component";
import {
    GrantsRoleGroupsComponent
} from "@features/settings/users-and-access/grants-role-groups/grants-role-groups.component";
import {GrantsRolesComponent} from "@features/settings/users-and-access/grants-roles/grants-roles.component";

const components = [
  BankingDetailsComponent,
  BillingDetailsComponent,
  GlobalSettingsComponent,
  HardwareSettingsComponent,
  ManageListingComponent,
  SettingsBillingAndBankingComponent,
  SettingsDetailsComponent,
  TemplateBuilderComponent,
  UploadOfferingListingPhotoDialogComponent,
  UsersAndAccessComponent,
  VerifyBankingDetailsComponent,
  AssignedSuppliersDialogComponent,
  PaymentsSettingsComponent,
];

@NgModule({
  imports: [
    MaterialModule,
    AppCoreModule,
    AppSharedModule,
    FeaturePortalModule,
    AppCardComponent,
    AppCardContentDirective,
    AppCardActionsDirective,
    GrantsRoleGroupsComponent,
    GrantsRolesComponent
  ],
  declarations: [...components],
  exports: [...components],
  providers: []
})
export class FeatureSettingsModule {
}
